<template>
  <button v-bind:class="show" @click="goToTop" class="gotop" title="Go to top">
    <i class="fas fa-chevron-circle-up"></i>
  </button>
</template>

<script>
export default {
  name: "Navbar.GoToTop",
  props: {
    visible: Boolean
  },
  computed: {
    show() {
      return {
        "d-flex": this.visible,
        "d-none": !this.visible
      };
    }
  },
  methods: {
    goToTop: function() {
      document.body.scrollTop = 0; // For Safari
      document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.gotop {
  position: fixed; /* Fixed/sticky position */
  bottom: 50px; /* Place the button at the bottom of the page */
  right: 30px; /* Place the button 30px from the right */
  z-index: 99; /* Make sure it does not overlap */
  border: none; /* Remove borders */
  outline: none; /* Remove outline */
  background-color: #563d7c; /* Set a background color */
  color: white; /* Text color */
  cursor: pointer; /* Add a mouse pointer on hover */
  padding: 15px; /* Some padding */
  border-radius: 10px; /* Rounded corners */
  font-size: 18px; /* Increase font size */
  opacity: 0.4;
}

.gotop:hover {
  background-color: #023e7e; /* Add a dark-grey background on hover */
  opacity: 0.6;
}
</style>
